import {Component, OnInit, OnChanges, Input, ViewChild} from '@angular/core';

@Component({
  selector: 'app-sidenav-item',
  templateUrl: './sidenav-item.component.html'
})

export class SidenavItemComponent implements OnInit, OnChanges {
  @Input() items;
  @Input() level;
  @ViewChild('childMenu') public childMenu;

  constructor() {
  }

  clearFocus(button) {
    button._elementRef.nativeElement.blur();
  }

  ngOnInit() {
  }

  ngOnChanges() {
  }
}
